import React, {Component} from 'react'
import {Grid, Hidden, withStyles} from "@material-ui/core"
import FontW7 from "../Font/FontW7";
import FontW5 from "../Font/FontW5";
import FontW9 from "../Font/FontW9";

const style = theme => ({
   fixHeight: {
      // height: 540,
      backgroundPosition: 'center',
      [theme.breakpoints.down('sm')]: {
         height: 300,
         margin: '5px 0',
      },
      backgroundSize: 'auto 100%',
      backgroundRepeat: 'no-repeat',
   },
   fixContent: {
      padding: '0px 15px',
      ['@media (min-width:960px)']: {
         maxWidth: 440
      },
      ['@media (min-width:992px)']: {
         maxWidth: 470,
         // marginRight: -25,
      },
      ['@media (min-width:1200px)']: {
         maxWidth: 585,
      },
      marginLeft: 'auto',
      // marginRight: -30,
      [theme.breakpoints.down('sm')]: {
         margin: '0 auto',
      }
   },
   fix150: {
      margin: 'auto 0px',
      textAlign: 'justify',
      textJustify: 'auto',
      [theme.breakpoints.down('sm')]: {
         marginTop: 10,
         marginBottom: 10,
         textAlign: 'center',
      },
   },
   title: {
      // whiteSpace: "nowrap",
      fontSize: "24pt",
      lineHeight: 1.5,
      [theme.breakpoints.down('sm')]: {
         fontSize: '18pt',
      },
   }
})

class AboutRight extends Component {
   render() {
      const {img, title, content, titleSignature, signature, classes, setMargin, setMarginLeft, setbgColor, setHeightImg} = this.props
      return (
         <div
            data-scroll-index="1"
            id="section-1"
            className={"clearfix about-style-2 " + classes.root}
            style={{
               paddingTop: 5,
               backgroundColor: setbgColor ? setbgColor : '#fff',
            }}
         >
            <Grid
               container
               className="container"
               justify={"center"}
            >
               <Hidden mdUp>
                  <Grid item xs={12} style={{display: 'flex'}}>
                     <div
                        className={"wow fadeInRight " + classes.fixHeight}
                        style={{
                           flex: 1,
                           backgroundImage: `url(${img})`,
                        }}
                        data-wow-delay=".3s"
                     />
                  </Grid>
               </Hidden>
               <Grid container item md={6} xs={12} className={classes.fixContent} style={{margin: setMarginLeft}}>
                  {/*<Grid item xs={12} className={classes.fixWidthContent}>*/}
                     <Grid item xs={12} className={"text-body wow fadeInLeft " + classes.fix150} data-wow-delay=".3s">
                        <FontW7 className={classes.title}>{title}</FontW7>
                        <div className="mt-30">
                           <FontW5 className="font-16px">{content}</FontW5>
                        </div>
                        <h4 style={{marginTop: 45}}><FontW5 className="font-18px">{titleSignature}</FontW5>
                        </h4>
                        <h2 style={{marginTop: 10, fontWeight: 'bolder'}}><FontW9
                           className="font-35px">{signature}</FontW9></h2>
                     </Grid>
                  {/*</Grid>*/}
               </Grid>
               <Hidden smDown>
                  <Grid
                     item
                     md={6}
                     className={"wow fadeInRight " + classes.fixHeight + ' ' + setMargin}
                     style={{
                        flex: 1,
                        backgroundImage: `url(${img})`,
                        display: 'flex',
                        height: setHeightImg ? setHeightImg : 540,
                     }}
                     data-wow-delay=".3s"
                  />
               </Hidden>
            </Grid>
         </div>
      )
   }
}

export default withStyles(style)(AboutRight)
